import cn from "classnames";
import "./Pagina.scss";

export interface Props {
  isHighlighted?: boolean;
  isEllipsis?: boolean;
  number: number;
  navigationHandler: (pageNum: number) => void;
  goToPageAriaLabel: string | undefined;
}
const Pagina = ({
  isHighlighted,
  isEllipsis,
  number,
  goToPageAriaLabel,
  navigationHandler,
}: Props) => (
  <>
    {!isEllipsis && !isHighlighted ? (
      <button
        onClick={() => navigationHandler(number)}
        className="pagina"
        aria-label={goToPageAriaLabel + " " + number}
      >
        <span>{number}</span>
      </button>
    ) : (
      <span
        aria-current="true"
        className={cn("pagina", {
          pagina__selected: isHighlighted,
          pagina__ellipsis: isEllipsis,
        })}
      >
        {isHighlighted ? number : <>&hellip;</>}
      </span>
    )}
  </>
);

export default Pagina;
